import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectRouteNestedParams } from '@ebeihilfe/core';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectApplicationsDetailsData = createSelector(getEinreichungState, (state: EinreichungState) => {
  return state.applicationsDetails.data;
});
export const selectApplicationsDetailsLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsDetails.loading,
);
export const selectApplicationsDetailsError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsDetails.error,
);
export const selectDocumentById = createSelector(
  getEinreichungState,
  selectRouteNestedParams,
  (state: EinreichungState) => state.applicationsDetails.data?.metadata?.formResults ?? [],
);
